module.exports = __webpack_public_path__ + "img/FR14120.17822005.png";